
// Devuelve un string limpio, sin caracteres especiales y en minúsculas
export const cleanString = (input: string): string => {
    return input
        .trim()
        .toLowerCase() // Convierte a minúsculas
        .replace(/[^a-z0-9]/g, ''); // Elimina caracteres que no sean letras o números
};

export const cleanHTML = (html: string) => {
  return html
    .replace(/<p><br><\/p>/g, "<br/>")
    .replace(/\n/g, "");
};

/**
 * Quill serialises ordinary spaces as U+00A0 (&nbsp;). Line breakers only treat
 * U+0020 as a wrap opportunity, so an nbsp-joined paragraph is seen as ONE
 * unbreakable word: the browser splits it mid-word, and @react-pdf/textkit
 * (which splits words on /([ ]+)/g) cannot wrap it at all and truncates the
 * line. Restore real spaces before rendering. Handles both the entity and the
 * decoded character, since the value may arrive in either form.
 */
export const normalizeNbsp = (html: string): string =>
  html.replace(/&nbsp;/gi, " ").replace(/\u00A0/g, " ");
